import React, {useContext, useEffect} from "react";
import {useLocation} from "wouter";
import {NavigationContext} from "@common/context/NavigationContext";

const useDynamicBreadcrumb = ({ label, path }) => {
    const [location] = useLocation();
    const { registerDynamicCrumb, unregisterDynamicCrumb } = useContext(NavigationContext);

    useEffect(() => {
        const pathForRegistration = path || location;

        if (label) {
            registerDynamicCrumb(pathForRegistration, label);
        }

        return () => {
            unregisterDynamicCrumb(pathForRegistration);
        };
    }, [location, label, path, registerDynamicCrumb, unregisterDynamicCrumb]);
};

export default useDynamicBreadcrumb;